export const WorkspaceConstant = {
    MiniToolBar: {
        SET_DEFAULT_BU: "Set as default",
        WORKING_COMPANY: "Working Company",
        PRINTER: "Printer",
    },
    Common: {
        CRITERIA_DIRECTORY: "CRITERIA DIRECTORY",
        BUTTON_IMPORT: "Import",
        BUTTON_RESET: "Reset",
        BUTTON_SEARCH: "Search",
        BUTTON_CLOSE: "Close",
        BUTTON_CANCEL: "Cancel",
        BUTTON_NEXT: "Next",
        BUTTON_PREV: "Prev",
        BUTTON_APPLY: "Apply",
        BUTTON_CONFIRM: "Confirm",
        BUTTON_CONFIRM_SUBMIT: "Confirm & Submit",
        BUTTON_CONFIRMALL: "Confirm All",
        BUTTON_APPLYALL: "Apply All",
        BUTTON_UNCONFIRM: "Un-Confirm",
        BUTTON_UNCONFIRMALL: "Un-Confirm All",
        BUTTON_UPDATE: "Update",
        BUTTON_UPDATEALL: "Update All",
        BUTTON_SAVE: "Save",
        BUTTON_COPY: "Copy",
        BUTTON_MORE: "More",
        BUTTON_DELETE: "Delete",
        BUTTON_ADJUSTMENT: "Adjustment",
        BUTTON_REPRINT: "Reprint",
        BUTTON_CHECKLIST: "Checklist",
        BUTTON_PRINT: "Print",
        BUTTON_ACCTML: "Acc Tml",
        BUTTON_RESUMEACCTML: "Resume Acc Tml",
        BUTTON_GENNONOPS: "Gen. Non-Ops",
        BUTTON_STD_BILL: "Std Bill",
        BUTTON_UPLOAD: "Upload",
        BUTTON_VIEW: "View",
        BUTTON_SHOWALL: "Show All",
        BUTTON_HIDEOTHERS: "Hide Others",
        BUTTON_GENDRAFTINVOICE: "Gen Draft Invoice",
        BUTTON_COPYARRIVALVESSEL: "Copy Arrival Vessel",
        BUTTON_COPYDEPATUREVESSEL: "Copy Depature Vessel",
        BUTTON_UPLOADSUPPORTING: "Upload Supporting",
        BUTTON_VIEWSUPPORTING: "View Supporting",
        BUTTON_UPLOADCNTR: "Upload Container",
        BUTTON_ADD: "Add",
        BUTTON_EXPORT: "Export",
        BUTTON_EXPORT_AS: "Export As",
        BUTTON_DOWNLOAD: "Download",
        BUTTON_DOWNLOAD_AS: "Download As",
        BUTTON_CLEAR: "Clear",
        BUTTON_REMOVE: "Remove",
        BUTTON_SUBMIT: "Submit",
        BUTTON_SUBMIT_ALL: "Submit All",
        BUTTON_GENGEATE: "Generate",
        BUTTON_APPROVE: "Approve",
        BUTTON_REJECT: "Reject",
        BUTTON_RESEND: "Resend",
        BUTTON_RESEND_ALL: "Resend All",
        BUTTON_COLLECTION: "Collection",
        BUTTON_SUBMIT_BY_SELECTION: "Submit By Selection",
        BUTTON_SUBMIT_BY_CRITERIA: "Submit By Criteria",
        BUTTON_SUBMIT_RECAL_SELECTION: "Submit Recal Selection",
        BUTTON_SUBMIT_RECAL_CRITERIA: "Submit Recal Criteria",

        MENU_MOVE_AFTER: "Move After",
        MENU_MOVE_CONFIRM: "Move Confirm"


    }
}